import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import client from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const FIELDS = [
  { key: "chk_mhq_SignedDocuments_ok", labelKey: "dealership.sadConfirmations.signedDocuments" },
  { key: "chk_mhq_datareviewed_ok", labelKey: "dealership.sadConfirmations.dataReviewed" },
  { key: "chk_mhq_commercially_eligible_ok", labelKey: "dealership.sadConfirmations.commerciallyEligible" },
];

/** MHQ-only sign-off checkboxes — visibility is gated by the caller
 * (MyDealership.jsx only renders this card when isMhq is true); the backend
 * additionally rejects the PATCH for any non-MHQ role. */
export function SadConfirmationsCard({ dealer, dealerId, onSaved }) {
  const { t } = useI18n();
  const [savingKey, setSavingKey] = useState(null);

  const toggle = async (key, value) => {
    setSavingKey(key);
    try {
      const { data } = await client.patch(`/dealers/${dealerId}/sad-confirmations`, { [key]: value });
      onSaved(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to update");
    } finally {
      setSavingKey(null);
    }
  };

  return (
    <Card className="mb-6 p-6" data-testid="sad-confirmations-card">
      <h2 className="mb-4 text-lg font-semibold">{t("dealership.sadConfirmations.title")}</h2>
      <div className="space-y-3">
        {FIELDS.map(({ key, labelKey }) => (
          <label key={key} className="flex items-center gap-2 text-sm" data-testid={`${key}-label`}>
            <Checkbox
              data-testid={key}
              checked={dealer[key] === true}
              disabled={savingKey === key}
              onCheckedChange={(v) => toggle(key, !!v)}
            />
            {t(labelKey)}
          </label>
        ))}
      </div>
    </Card>
  );
}
